import ImgMedical from "../images/img-medical.svg";
import ImgPatientWard from "../images/img-patient-ward.svg";
import ImgTestRoom from "../images/img-test-room.svg";
import ImgIcu from "../images/img-icu.svg";

const features = [
    {
      name: "Medical",
      image: ImgMedical,
    },
    {
      name: "Patient Ward",
      image: ImgPatientWard,
    },
    {
      name: "Test Room",
      image: ImgTestRoom,
    },
    {
      name: "ICU",
      image: ImgIcu,
    },
    {
      name: "Test Room",
      image: ImgTestRoom,
    },
    {
      name: "ICU",
      image: ImgIcu,
    },
  ];

  export default features